// Single source of truth for Premium pricing on the frontend.
// Backend is the authoritative source — these values are used only as
// fallbacks before the /api/subscription/config response arrives.
export const PRICING_FALLBACK = {
  price_inr: 299,
  original_price_inr: 1999,
  savings_inr: 1700,
  offer_label: "LAUNCH OFFER",
  currency: "INR",
  plan: "yearly",
  plan_days: 365,
};

export function formatPrice(inr) {
  try {
    return new Intl.NumberFormat("en-IN").format(inr);
  } catch {
    return String(inr);
  }
}

// Merges a fetched /subscription/config object with fallbacks.
export function withPricing(config) {
  return { ...PRICING_FALLBACK, ...(config || {}) };
}
